import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=3fa1fd9a&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/irvan/ECLIPSE/br-monorepo/js/solvent_js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa1fd9a')) {
      api.createRecord('3fa1fd9a', component.options)
    } else {
      api.reload('3fa1fd9a', component.options)
    }
    module.hot.accept("./PhoneNumberInput.vue?vue&type=template&id=3fa1fd9a&", function () {
      api.rerender('3fa1fd9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/solvent/PhoneNumberInput.vue"
export default component.exports